import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React from "react";
import success from "../../images/success.png";
import { useNavigate } from "react-router-dom";

const PasswordChangeSuccessModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate(); // Hook to programmatically navigate

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-[#21140E0F] px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="justify-items-center ">
                  <img src={success} />
                </div>
                <div className="mt-2 text-center">
                  <p className="text-2xl font-semibold text-[#284184]">
                    Password Update <br /> Successfully
                  </p>
                  <p className="text-sm mt-3 text-[#8B8D98]">
                    Your password has been update successfully
                  </p>
                </div>
                <div className="text-center mt-4">
                  <button
                    type="button"
                    onClick={() => {
                      onClose();
                      navigate("/auth/login");
                    }}
                    className="w-full justify-center rounded-md bg-[#284184] px-3 py-2 text-sm font-semibold text-white shadow-sm"
                  >
                    Back to Login
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default PasswordChangeSuccessModal;
